import React from 'react';
import { Button } from '@mui/material';

const GetInTouchButton = (size = 'small', sx = {}, theme = 'light') => {
  const isDark = theme === 'dark';

  return (
    <Button
      variant={isDark ? 'contained' : 'outlined'}
      className={size === 'small' ? '' : 'w-full md:w-auto'}
      size={size}
      sx={{
        mt: size === 'small' ? 1.5 : 2,
        textTransform: 'none',
        fontWeight: 600,
        alignSelf: 'center',
        borderRadius: 2,
        ...(isDark
          ? {
              backgroundColor: '#0f172a',
              color: '#fff',
              borderColor: '#0f172a',
              '&:hover': {
                backgroundColor: '#0b1221',
                borderColor: '#0b1221',
              },
            }
          : {
              backgroundColor: 'transparent',
              color: '#0f172a',
              borderColor: '#e2e8f0',
              '&:hover': {
                backgroundColor: '#f1f5f9',
                borderColor: '#cbd5e1',
              },
            }),
        visibility: 'visible',
        ...sx,
      }}
      // target="_blank"
      href="/contact"
    >
      Get in Touch
    </Button>
  );
};

export default GetInTouchButton;
